import { render, staticRenderFns } from "./SectionProductsForm.vue?vue&type=template&id=7db093c1&"
import script from "./SectionProductsForm.vue?vue&type=script&lang=js&"
export * from "./SectionProductsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports